<template>
  <v-container fluid class="no-padding-top">
    <v-row no-gutters>
      <v-col cols="12" class="limited-scrollable">
        <OrderDetails
          :orderId="$route.params.orderId"
          :orderIncrementId="$route.params.orderIncrementId"
          :showAction="$route.params.showAction" />
      </v-col>
  </v-row>
  </v-container>
</template>

<script>
  import OrderDetails from '../components/OrderDetails';

  export default {
    name: 'Order',
    components: {
      OrderDetails
    },
    data: () => ({}),
    mounted() {},
    methods: {},
  }
</script>

<style scoped></style>